import { WS_PROTOCOL, API_APPLICATION_HOST } from '@libs/utils/environments'

export const NOT_FOUND = 'not_found'

export const SOCKET_REJECT_SUBSCRIPTION = 'reject_subscription'
export const SOCKET_CONFIRM_SUBSCRIPTION = 'confirm_subscription'
export const SOCKET_URL = `${
  WS_PROTOCOL || 'wss'
}://${API_APPLICATION_HOST}/api/cable`
